import {guestAccessTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = guestAccessTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const guestAccessReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default guestAccessReducer;
